import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import toast from "react-hot-toast";
import {
  addState,
  deleteState,
  getCountries,
  getStates,
  updateState,
} from "../../Services/HomeService";
import Swal from "sweetalert2";

const ManageState = () => {
  const initialValues = {
    countryId: "",
    stateName: "",
  };
  const [formData, setFormData] = useState(initialValues);
  const [createStateLoading, setCreateStateLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [fetchStatesLoading, setFetchStatesLoading] = useState(false);
  const [editState, setEditState] = useState(null);
  const [updateStateLoading, setUpdateStateLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [fetchCountriesLoading, setFetchCountriesLoading] = useState(false);

  const fetchCountries = async () => {
    try {
      setFetchCountriesLoading(true);
      const res = await getCountries();
      console.log("fetched counries", res);
      if (res?.status) {
        setCountries(res?.data);
        setFetchCountriesLoading(false);
      } else {
        toast.error("Error while Fetching Counries Data");
        setFetchCountriesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Counries Data");
      console.error("Error fetching Counries:", error);
      setFetchCountriesLoading(false);
    }
  };

  const fetchStates = async () => {
    try {
      setFetchStatesLoading(true);
      const res = await getStates();
      console.log("fetched states", res);
      if (res?.status) {
        setStates(res?.data);
        setFetchStatesLoading(false);
      } else {
        toast.error("Error while Fetching States Data");
        setFetchStatesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch States Data");
      console.error("Error fetching State:", error);
      setFetchStatesLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
    fetchStates();
  }, []);

  const handleCreateState = async (e) => {
    e?.preventDefault();
    if (!formData.stateName) {
      toast.error("Please Enter State Name");
      return;
    }
    try {
      setCreateStateLoading(true);
      const res = await addState(formData);
      console.log("State Add Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("State added successfully!");
        setFormData(initialValues);
        fetchStates();
        setCreateStateLoading(false);
      } else {
        toast.error(res?.message);
        setCreateStateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add State.");
      console.error("Error adding State:", error);
      setCreateStateLoading(false);
    }
  };

  const handleUpdateClick = (row) => {
    setEditState(row);
  };

  const handleCancel = () => {
    setEditState(null);
  };

  const handleUpdateState = async (e) => {
    e?.preventDefault();
    if (!editState?.stateName) {
      toast.error("Please Enter State Name");
      return;
    }
    try {
      setUpdateStateLoading(true);
      const res = await updateState(editState?._id, {
        stateName: editState?.stateName,
      });
      console.log("State Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // toast.success("State added successfully!");
        fetchStates();
        setEditState(null);
        setUpdateStateLoading(false);
      } else {
        toast.error(res?.message);
        setUpdateStateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add State.");
      console.error("Error adding State:", error);
      setUpdateStateLoading(false);
    }
  };

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete State?",
      text: "Are you sure you want to delete this State?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      confirmButtonColor: "#d33",
      cancelButtonText: "Cancel",
      reverseButtons: true,
    });
    if (result.isConfirmed) {
      try {
        await deleteState(id);
        Swal.fire("Deleted!", "City has been deleted.", "success");
        fetchStates();
      } catch (error) {
        Swal.fire("Error!", "Failed to delete city.", "error");
      }
    }
  };

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };
  const customStyles = {
    headCells: {
      style: {
        fontSize: "15px",
        fontWeight: "bold",
        color: "#333",
      },
    },
  };

  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      sortable: true,
      center: true,
    },
    {
      name: "Country",
      selector: (row) => row.country?.countryName,
      sortable: true,
      center: true,
    },
    {
      name: "State",
      selector: (row) => row.stateName,
      sortable: true,
      center: true,
    },
    {
      name: "Action",
      center: true,
      cell: (row) => (
        <>
          <span title="Edit">
            <i
              onClick={() => {
                handleUpdateClick(row);
              }}
              className="fa-solid fa-pen-to-square"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "rgb(133, 218, 79)",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span>
          {/* <span title="Delete">
            <i
              onClick={() => {
                handleDelete(row?._id);
              }}
              className="fa-solid fa-trash-can text-danger"
              style={{
                cursor: "pointer",
                padding: "5px",
                marginRight: "5px",
                fontSize: "1.5em",
                color: "#477DA5",
                backgroundColor: "#E9F3F7",
              }}
            ></i>
          </span> */}
        </>
      ),
    },
  ];

  return (
    <>
      {!editState && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Manage State
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleCreateState(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      Country<span className="text-danger">*</span>
                    </label>
                    <select
                      required
                      className="form-control"
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          countryId: e?.target?.value,
                        }));
                      }}
                      value={formData?.countryId}
                    >
                      <option value="">-------- Select Country --------</option>
                      {fetchCountriesLoading ? (
                        <option>Loading...</option>
                      ) : countries?.length === 0 ? (
                        <option disabled>No Country Found</option>
                      ) : (
                        countries?.map((e, i) => {
                          return (
                            <option key={i} value={e?._id}>
                              {e?.countryName}
                            </option>
                          );
                        })
                      )}
                    </select>
                  </div>

                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={formData?.stateName}
                      onChange={(e) => {
                        setFormData((prev) => ({
                          ...prev,
                          stateName: e?.target?.value,
                        }));
                      }}
                      type="text"
                      className="form-control"
                      placeholder="Enter State Name"
                      required
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-center">
                  <button
                    disabled={createStateLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {createStateLoading ? "Loading..." : "Add State"}
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
      {!editState && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <section className="chartBox_area">
              <DataTable
                data={states}
                columns={columns}
                pagination
                responsive
                highlightOnHover
                customStyles={customStyles}
                progressPending={fetchStatesLoading}
              />
            </section>
          </div>
        </div>
      )}
      {editState && (
        <div className="main_wrap" style={{ marginTop: "6rem" }}>
          <div className="container-fluid">
            <div style={headLineStyle} className="page-headline">
              Update State
            </div>
            <section className="chartBox_area">
              <form
                onSubmit={(e) => {
                  handleUpdateState(e);
                }}
              >
                <div className="row d-flex justify-content-center">
                  <div className="col-md-6 mt-3">
                    <label htmlFor="name">
                      State Name<span className="text-danger">*</span>
                    </label>
                    <input
                      value={editState?.stateName}
                      onChange={(e) => {
                        setEditState((prev) => ({
                          ...prev,
                          stateName: e.target.value,
                        }));
                      }}
                      type="text"
                      id="name"
                      className="form-control"
                      placeholder="Enter State Name"
                      required
                    />
                  </div>
                </div>
                <div
                  className=" d-flex justify-content-center gap-4"
                  style={{ gap: "15px" }}
                >
                  <button
                    disabled={updateStateLoading}
                    type="submit"
                    className="btn mt-3"
                    style={{
                      background: "rgb(133, 218, 79)",
                      borderRadius: "13px",
                    }}
                  >
                    {updateStateLoading ? "Loading..." : "Update"}
                  </button>
                  <button
                    onClick={() => {
                      handleCancel();
                    }}
                    disabled={updateStateLoading}
                    type="button"
                    className="btn mt-3"
                    style={{
                      background: "#f77754",
                      borderRadius: "13px",
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default ManageState;
